<template>
  <section id="filmAngebot" class="site">
    <h1>Filmangebot</h1>
    <article class="offer-block">
      <div class="offer-title"><h3>Für Firmen</h3></div>
      <div class="subblock-wrapper">
        <div
          class="offer-subblock"
          v-for="(offer, index) in FirmenFilmOffer"
          :key="index"
          v-scroll-reveal
        >
          <img :src="offer.img" alt="" />
          <div class="cont-wrapper">
            <div class="desc-wrapper">
              <h2>{{ offer.title }}</h2>
              <h3>{{ offer.price }}</h3>
              <p v-html="offer.detail">{{ offer.detail }}</p>
            </div>
            <div class="btn-wrapper">
              <a href="mailto:info@ocular.ch">
                <button class="btn-small btn-blue">Anfrage</button>
              </a>
              <router-link :to="`/filme/${offer.example}`">
                <button class="btn-small btn-gray">Beispiel</button>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </article>

    <article class="offer-block">
      <div class="offer-title"><h3>Hochzeit & Events</h3></div>
      <div class="subblock-wrapper">
        <div
          class="offer-subblock"
          v-for="(offer, index) in EventFilmOffer"
          :key="index"
          v-scroll-reveal
        >
          <img :src="offer.img" alt="" />
          <div class="cont-wrapper">
            <div class="desc-wrapper">
              <h2>{{ offer.title }}</h2>
              <h3>{{ offer.price }}</h3>
              <p v-html="offer.detail">{{ offer.detail }}</p>
            </div>
            <div class="btn-wrapper">
              <a href="mailto:info@ocular.ch">
                <button class="btn-small btn-blue">Anfrage</button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </article>
  </section>
</template>

<script>
export default {
  name: "FilmOffer",
  computed: {
    FirmenFilmOffer() {
      return this.$store.state.FirmenFilmOffer;
    },
    EventFilmOffer() {
      return this.$store.state.EventFilmOffer;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
